import { TextBadge } from 'components/Badge/TextBadge';
import { SearchFilterAccordionItem } from 'modules/search/components/Filters/AccordionItem/SearchFilterAccordionItem';
import { SearchFilterDropdown } from 'modules/search/components/Filters/Dropdown/SearchFilterDropdown';
import { SearchFilterCheckboxFacetOptions } from 'modules/search/components/Filters/FacetOptions/SearchFilterCheckboxFacetOptions';
import { useSearchFacetSelectedValues } from 'modules/search/hooks/filters/useSearchFacetSelectedValues';
import { SearchFilterVariant } from 'modules/search/types/SearchFilterVariant';
import { EMPLOYMENT_TYPE_CHECKBOX_OPTIONS } from 'utils/constants/general/employmentTypes';

type Props = {
  variant?: SearchFilterVariant;
};
export function EmploymentTypeFilter({ variant = 'dropdown' }: Props) {
  const selectedFilterValues = useSearchFacetSelectedValues('jobType');

  const FilterVariant =
    variant === 'accordion' ? SearchFilterAccordionItem : SearchFilterDropdown;

  return (
    <FilterVariant
      facetType="jobType"
      icon="hammer"
      label={
        <>
          {getText('Job Type')}{' '}
          <TextBadge content={selectedFilterValues.length} />
        </>
      }
    >
      <SearchFilterCheckboxFacetOptions
        facetType="jobType"
        initialValue={selectedFilterValues}
        options={EMPLOYMENT_TYPE_CHECKBOX_OPTIONS}
      />
    </FilterVariant>
  );
}
